import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';

type NumberedStep = {
  number: number;
  text: string;
  subText?: string;
};

type NumberedStepsProps = ComponentProps<'div'> & {
  steps: NumberedStep[];
};

function NumberedSteps({ steps, className = 'py-4', ...props }: NumberedStepsProps) {
  return (
    <div data-testid="numbered-steps" className={twMerge('flex flex-col md:flex-row gap-2 md:gap-12 md:items-start md:justify-center', className)} {...props}>
      {steps.map(step => (
        <div key={step.number} className="flex gap-6 md:gap-4 items-center" data-testid={`numbered-step-${step.number}`}>
          <div className="flex-shrink-0 w-11 flex justify-center">
            <span className="text-accent-green heading-2" data-testid={`step-number-${step.number}`}>
              {step.number}
            </span>
          </div>
          <div className="flex flex-col">
            <p className="display-xs-strong" data-testid={`step-title-${step.number}`}>
              {step.text}
            </p>
            {step.subText && (
              <p className="paragraph-s" data-testid={`step-subtitle-${step.number}`}>
                {step.subText}
              </p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export { NumberedSteps };
export type { NumberedStep, NumberedStepsProps };
